
/**
 * 결제 주기
 */
export type PlanResponse2BillingCycle = typeof PlanResponse2BillingCycle[keyof typeof PlanResponse2BillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanResponse2BillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
